import type { StatusFailureEvent } from "@/hooks/use-status-failure-ws";
import { AlertCircle } from "lucide-react";

interface StatusFailureBannerProps {
	lastFailure: StatusFailureEvent | null;
	onDismiss: () => void;
}

export function StatusFailureBanner({
	lastFailure,
	onDismiss,
}: StatusFailureBannerProps) {
	if (!lastFailure) return null;

	const label = lastFailure.serviceName ?? lastFailure.serviceId;
	const time = lastFailure.checkedAt
		? new Date(lastFailure.checkedAt).toLocaleString()
		: "";

	return (
		<div
			role="alert"
			className="flex items-center gap-3 bg-destructive text-destructive-foreground px-4 py-3 text-sm shadow-lg"
		>
			<AlertCircle className="h-5 w-5 shrink-0" />
			<div className="flex-1 min-w-0">
				<span className="font-medium">Service down:</span> {label}
				{lastFailure.error && (
					<span className="text-destructive-foreground/90 ml-1">
						({lastFailure.error})
					</span>
				)}
				{time && (
					<span className="block text-xs mt-0.5 opacity-90">{time}</span>
				)}
			</div>
			<button
				type="button"
				onClick={onDismiss}
				className="shrink-0 rounded px-2 py-1 hover:bg-destructive-foreground/20 transition-colors font-medium"
				aria-label="Dismiss"
			>
				Dismiss
			</button>
		</div>
	);
}
